module.exports = __webpack_public_path__ + "60bbfcdf856e92d45f20f2f9d8a3eb99.png";